import { AdjustOutlined } from "@mui/icons-material";
import { Paper, Slider, Stack, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
export const BRUSH_SIZE_SLIDER_ID = 'hexmap-brush-size-slider';
export const BrushSizeSlider = ({ brushSize, maxBrushSize, onChange }) => {
    const [internalValue, setInternalValue] = useState(brushSize);
    useEffect(() => onChange(internalValue), [internalValue]);
    return (React.createElement(Paper, null,
        React.createElement(Stack, { alignItems: "center" },
            React.createElement(Tooltip, { title: "Brush Size", arrow: true, placement: "left", enterDelay: 500, enterTouchDelay: 500 },
                React.createElement(AdjustOutlined, { sx: { cursor: 'help', margin: '0.25em', marginBottom: '0.5em' } })),
            React.createElement(Slider, { "aria-label": "Brush Size", orientation: "vertical", valueLabelDisplay: "auto", value: brushSize, max: maxBrushSize, min: 1, onChange: (_, value) => typeof value === 'number' && setInternalValue(value), sx: { minHeight: 100, marginTop: '0.5em', marginBottom: '1.25em' } }))));
};
//# sourceMappingURL=BrushSizePane.js.map